import gql from 'graphql-tag';

const ruleEvaluationOutcomesQuery = gql`
  query RuleEvaluationOutcomes($orderId: ID!) {
    ruleEvaluationOutcomes(orderId: $orderId) {
      ruleName
      passed
      reason
    }
  }
`;

export default ruleEvaluationOutcomesQuery;
